import React from 'react';

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          padding: '20px', 
          textAlign: 'center',
          backgroundColor: '#f8f9fa',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <h1 style={{ color: '#dc3545', marginBottom: '20px' }}>
            ¡Oops! Algo salió mal
          </h1>
          <p style={{ marginBottom: '20px', color: '#6c757d' }}>
            Ha ocurrido un error inesperado en la aplicación.
          </p>
          
          {/* Información específica del error */}
          <div style={{ 
            backgroundColor: '#fff3cd', 
            border: '1px solid #ffeaa7',
            borderRadius: '4px',
            padding: '15px',
            marginBottom: '20px',
            maxWidth: '600px'
          }}>
            <strong>Error:</strong> {this.state.error?.message || 'Error desconocido'}
          </div>

          <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
            <button 
              onClick={() => window.location.reload()}
              style={{
                padding: '10px 20px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              🔄 Recargar página
            </button>
            
            <button 
              onClick={() => window.location.href = '/'}
              style={{
                padding: '10px 20px',
                backgroundColor: '#28a745',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              🏠 Ir al inicio
            </button>
          </div>

          <details style={{ marginBottom: '20px', textAlign: 'left', maxWidth: '800px' }}>
            <summary style={{ cursor: 'pointer', marginBottom: '10px' }}>
              🔍 Ver detalles técnicos del error
            </summary>
            <pre style={{ 
              backgroundColor: '#f1f3f4', 
              padding: '10px', 
              borderRadius: '4px',
              fontSize: '12px',
              overflow: 'auto',
              whiteSpace: 'pre-wrap'
            }}>
              {this.state.error?.stack || this.state.error?.message || 'Error desconocido'}
            </pre>
          </details>

          <p style={{ fontSize: '14px', color: '#6c757d' }}>
            Si el problema persiste, contacta al administrador del sistema.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}